import Vue from 'vue';
import Router from 'vue-router';
import PlayerView from './views/Player.vue';
import ErrorView from './views/Error.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/player',
    //   name: 'player',
    //   component: PlayerView,
    //   props: true,
    //   // beforeEnter: (to, from, next) => {
    //   //   // ...
    //   // }
    // },
    // {
    //   path: '/error',
    //   name: 'error',
    //   component: ErrorView,
    //   // beforeEnter: (to, from, next) => {
    //   //   // ...
    //   // }
    // },
  ],
});
